(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["5rwklpV2"] && !Shopify.designMode) return;
  try {
    
  /**
   * 5RWKLP v2 — sticky countdown timer.
   * Ticks once per second. When it hits zero it stops; doesn't reset
   * to avoid a "fake urgency that never ends" experience.
   */
  (function () {
    var el = document.querySelector('[data-kst-timer]');
    if (!el) return;

    var h = parseInt(el.dataset.hours, 10) || 0;
    var m = parseInt(el.dataset.minutes, 10) || 0;
    var s = parseInt(el.dataset.seconds, 10) || 0;

    var $h = el.querySelector('[data-kst-t="h"]');
    var $m = el.querySelector('[data-kst-t="m"]');
    var $s = el.querySelector('[data-kst-t="s"]');

    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    function render() {
      if ($h) $h.textContent = pad(h);
      if ($m) $m.textContent = pad(m);
      if ($s) $s.textContent = pad(s);
    }

    render();

    var iv = setInterval(function () {
      s--;
      if (s < 0) { s = 59; m--; }
      if (m < 0) { m = 59; h--; }
      if (h < 0) { clearInterval(iv); h = 0; m = 0; s = 0; }
      render();
    }, 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kst-customer-questions"] && !Shopify.designMode) return;
  try {
    
class KstQuestionList extends HTMLElement {
  connectedCallback() {
    this.rows = Array.from(this.querySelectorAll('[data-cq-row]'));
    this.note = this.querySelector('[data-cq-note]');
    this.input = this.querySelector('[data-cq-search]');

    this.onClick = this.#onClick.bind(this);
    this.addEventListener('click', this.onClick);

    if (this.input) {
      this.onInput = this.#onInput.bind(this);
      this.input.addEventListener('input', this.onInput);
      this.input.addEventListener('search', this.onInput);
    }

    this.onResize = this.#onResize.bind(this);
    window.addEventListener('resize', this.onResize, { passive: true });

    // Measure after layout so clamped text reports a real scrollHeight.
    this.raf = requestAnimationFrame(() => this.#measureClamps());
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
    if (this.input && this.onInput) {
      this.input.removeEventListener('input', this.onInput);
      this.input.removeEventListener('search', this.onInput);
    }
    window.removeEventListener('resize', this.onResize);
    if (this.raf) cancelAnimationFrame(this.raf);
    if (this.resizeTimer) clearTimeout(this.resizeTimer);
    if (this.searchTimer) clearTimeout(this.searchTimer);
  }

  /* Only offer "see more" where the text is genuinely cut off. */
  #measureClamps() {
    this.querySelectorAll('[data-cq-clamp]').forEach((text) => {
      const button = text.parentElement.querySelector('[data-cq-expand]');
      if (!button) return;
      if (text.hasAttribute('data-cq-open')) return;
      if (text.offsetParent === null && text.getClientRects().length === 0) return;
      button.hidden = text.scrollHeight <= text.clientHeight + 1;
    });
  }

  #onResize() {
    if (this.resizeTimer) clearTimeout(this.resizeTimer);
    this.resizeTimer = setTimeout(() => this.#measureClamps(), 150);
  }

  #onClick(event) {
    const vote = event.target.closest('[data-cq-vote]');
    if (vote && this.contains(vote)) return this.#vote(vote);

    const expand = event.target.closest('[data-cq-expand]');
    if (expand && this.contains(expand)) return this.#expand(expand);

    const toggle = event.target.closest('[data-cq-toggle]');
    if (toggle && this.contains(toggle)) return this.#toggle(toggle);
  }

  #vote(button) {
    const row = button.closest('[data-cq-row]');
    if (!row) return;
    const direction = Number(button.dataset.cqVote);
    const current = Number(row.dataset.cqDir || 0);
    const next = current === direction ? 0 : direction;
    row.dataset.cqDir = String(next);

    const count = row.querySelector('[data-cq-count]');
    if (count) {
      const base = Number(count.dataset.cqBase || 0);
      count.textContent = String(base + next);
    }

    row.querySelectorAll('[data-cq-vote]').forEach((b) => {
      const pressed = next !== 0 && Number(b.dataset.cqVote) === next;
      b.setAttribute('aria-pressed', String(pressed));
    });
  }

  #expand(button) {
    const text = button.parentElement.querySelector('[data-cq-clamp]');
    if (!text) return;
    const open = text.hasAttribute('data-cq-open');
    if (open) {
      text.removeAttribute('data-cq-open');
    } else {
      text.setAttribute('data-cq-open', '');
    }
    button.setAttribute('aria-expanded', String(!open));
    button.textContent = open ? this.dataset.seeMoreLabel : this.dataset.seeLessLabel;
  }

  #toggle(button) {
    const row = button.closest('[data-cq-row]');
    if (!row) return;
    const open = button.getAttribute('aria-expanded') === 'true';
    row.querySelectorAll('[data-cq-extra]').forEach((el) => {
      el.hidden = open;
    });
    button.setAttribute('aria-expanded', String(!open));

    const label = button.querySelector('[data-cq-toggle-label]');
    if (label) {
      const template = open ? this.dataset.moreLabel : this.dataset.lessLabel;
      label.textContent = (template || '').replace('[count]', button.dataset.cqExtraCount || '');
    }

    // Newly revealed answers have never been measured.
    this.#measureClamps();
  }

  #onInput() {
    if (this.searchTimer) clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => this.#filter(), 120);
  }

  #filter() {
    const raw = this.input.value.trim();
    const query = raw.toLowerCase();
    let shown = 0;

    this.rows.forEach((row) => {
      const match = !query || (row.dataset.cqText || '').indexOf(query) !== -1;
      row.hidden = !match;
      if (match) shown += 1;
    });

    if (!this.note) return;
    const questions = this.dataset.totalQuestions || '0';
    const answers = this.dataset.totalAnswers || '0';

    let text;
    if (!query) {
      text = (this.dataset.noteDefault || '')
        .replace('[questions]', questions)
        .replace('[answers]', answers);
    } else if (shown === 0) {
      text = (this.dataset.noteEmpty || '').replace('[query]', raw);
    } else {
      text = (this.dataset.noteFiltered || '')
        .replace('[shown]', String(shown))
        .replace('[questions]', questions);
    }
    this.note.textContent = text;

    if (query) this.#measureClamps();
  }
}

if (!customElements.get('kst-question-list')) {
  customElements.define('kst-question-list', KstQuestionList);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kst-expect-timeline"] && !Shopify.designMode) return;
  try {
    
class KstRevealList extends HTMLElement {
  connectedCallback() {
    if (this.dataset.animate === 'false') return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;

    const items = Array.from(this.querySelectorAll('[data-kst-reveal]'));
    if (!items.length) return;

    // Only now do the items become hidden — never before JS is confirmed alive.
    this.setAttribute('data-reveal-ready', '');

    let shown = 0;
    const reveal = (el) => {
      if (el.hasAttribute('data-kst-revealed')) return;
      el.style.transitionDelay = Math.min(shown, 3) * 110 + 'ms';
      shown += 1;
      el.setAttribute('data-kst-revealed', '');
    };

    this.observer = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        obs.unobserve(entry.target);
        reveal(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.01 });

    items.forEach((el) => this.observer.observe(el));

    // Fail-open: copy is never left invisible, whatever the observer does.
    this.failOpen = setTimeout(() => {
      items.forEach(reveal);
      this.#teardown();
    }, 2500);
  }

  disconnectedCallback() {
    this.#teardown();
  }

  #teardown() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
    if (this.failOpen) {
      clearTimeout(this.failOpen);
      this.failOpen = null;
    }
  }
}

if (!customElements.get('kst-reveal-list')) {
  customElements.define('kst-reveal-list', KstRevealList);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kst-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('[data-kst-scroll-top]');
    if (!trigger) return;
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kst-lp-base"]) return;
  try {
    
(function(){
  if (window.__kstLpInit) return;
  window.__kstLpInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(){
    // scroll reveal
    if ('IntersectionObserver' in window && !reduce){
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if (e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12 });
      document.querySelectorAll('.kst-reveal').forEach(function(el){ io.observe(el); });
    } else {
      document.querySelectorAll('.kst-reveal').forEach(function(el){ el.classList.add('is-in'); });
    }

    // smooth scroll: every [data-kst-scroll] -> the offer section
    document.querySelectorAll('[data-kst-scroll]').forEach(function(a){
      a.addEventListener('click', function(ev){
        var target = document.getElementById('kst-offer');
        if (!target) return;
        ev.preventDefault();
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      });
    });

    // sticky mobile CTA: show after hero, hide at offer
    var sticky = document.getElementById('kst-sticky');
    var hero = document.querySelector('[data-kst-hero]');
    var offer = document.getElementById('kst-offer');
    if (sticky && hero && 'IntersectionObserver' in window){
      var so = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if (e.target === hero){ sticky.classList.toggle('is-show', !e.isIntersecting && window.innerWidth <= 900); }
          if (e.target === offer && e.isIntersecting){ sticky.classList.remove('is-show'); }
        });
      }, { threshold: 0 });
      so.observe(hero);
      if (offer) so.observe(offer);
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kst-product-showcase"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var carousels = document.querySelectorAll('[data-kst-carousel]');
    carousels.forEach(function(carousel) {
      var track = carousel.querySelector('[data-track]');
      var slides = track.querySelectorAll('.kst-carousel__slide');
      var dots = carousel.querySelectorAll('[data-dot]');
      var prev = carousel.querySelector('[data-prev]');
      var next = carousel.querySelector('[data-next]');
      var idx = 0;

      if (slides.length <= 1) return;

      track.classList.add('is-ready');
      slides[0].classList.add('is-active');

      function go(newIdx) {
        slides[idx].classList.remove('is-active');
        slides[idx].setAttribute('aria-hidden', 'true');
        if (dots[idx]) {
          dots[idx].classList.remove('is-active');
          dots[idx].setAttribute('aria-selected', 'false');
        }
        idx = (newIdx + slides.length) % slides.length;
        slides[idx].classList.add('is-active');
        slides[idx].removeAttribute('aria-hidden');
        if (dots[idx]) {
          dots[idx].classList.add('is-active');
          dots[idx].setAttribute('aria-selected', 'true');
        }
      }

      if (prev) prev.addEventListener('click', function() { go(idx - 1); });
      if (next) next.addEventListener('click', function() { go(idx + 1); });
      dots.forEach(function(dot, i) {
        dot.addEventListener('click', function() { go(i); });
      });

      carousel.addEventListener('keydown', function(e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1); }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kst-rs-ba"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    (root || document).querySelectorAll('[data-rs-rail]').forEach(function(rail){
      if (rail.dataset.rsReady) return;
      rail.dataset.rsReady = '1';
      var dots = rail.parentElement.querySelectorAll('[data-rs-dots] i');
      if (!dots.length) return;
      var cards = rail.children;
      rail.addEventListener('scroll', function(){
        var max = rail.scrollWidth - rail.clientWidth;
        var i = max > 0 ? Math.round((rail.scrollLeft / max) * (cards.length - 1)) : 0;
        dots.forEach(function(d, n){ d.classList.toggle('is-active', n === i); });
      }, { passive: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ init(); });
  else init();
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kst-rs-buy"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    (root || document).querySelectorAll('[data-rs-gallery]').forEach(function(g){
      if (g.dataset.rsReady) return;
      g.dataset.rsReady = '1';
      var track = g.querySelector('[data-rs-track]');
      if (!track) return;
      var slides = track.querySelectorAll('[data-rs-slide]');
      var thumbs = g.querySelectorAll('[data-rs-thumb]');
      var prev = g.querySelector('[data-rs-prev]');
      var next = g.querySelector('[data-rs-next]');
      var strip = g.querySelector('.kst-rs-buy__thumbs');
      var current = 0;
      function go(i){
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }
      function mark(i){
        if (i === current && g.dataset.rsMarked) return;
        g.dataset.rsMarked = '1';
        current = i;
        thumbs.forEach(function(t, n){
          var on = n === i;
          t.classList.toggle('is-active', on);
          // Keep the active thumb visible by scrolling the thumb strip only.
          // (scrollIntoView would also scroll the page, jumping it on load.)
          if (on && strip) {
            var sr = strip.getBoundingClientRect(), tr = t.getBoundingClientRect();
            if (tr.left < sr.left) strip.scrollLeft -= sr.left - tr.left;
            else if (tr.right > sr.right) strip.scrollLeft += tr.right - sr.right;
          }
        });
        slides.forEach(function(s, n){
          var v = s.querySelector('video');
          if (!v) return;
          if (n === i && v.autoplay) { v.play().catch(function(){}); } else if (n !== i) { v.pause(); }
        });
        if (prev) prev.disabled = i === 0;
        if (next) next.disabled = i === slides.length - 1;
      }
      var ticking = false;
      track.addEventListener('scroll', function(){
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function(){
          ticking = false;
          mark(Math.round(track.scrollLeft / Math.max(1, track.clientWidth)));
        });
      }, { passive: true });
      thumbs.forEach(function(t){
        t.addEventListener('click', function(){ go(parseInt(t.getAttribute('data-rs-thumb'), 10)); });
      });
      if (prev) prev.addEventListener('click', function(){ go(current - 1); });
      if (next) next.addEventListener('click', function(){ go(current + 1); });
      mark(0);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ init(); });
  else init();
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
  document.addEventListener('shopify:block:select', function(e){
    var slide = e.target.closest && e.target.closest('[data-rs-slide]');
    if (!slide) return;
    var track = slide.closest('[data-rs-track]');
    if (track) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kst-timeline-1"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(e) {
    var t = e.target.closest('[data-kst-scroll-top]');
    if (!t) return;
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  });

  } catch(e) { console.error(e); }
})();
})();
